export default function(el) {

    el.addEventListener('click', e => {
      let question = e.currentTarget.dataset.confirm;
      if (!confirm(question)) {
        e.preventDefault();
      }
    });
  


}